<template>
    <v-dialog v-model="dialogVisible" max-width="600px" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ getDialogTitle() }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <TagForm :tag="tag" :mode="mode" :initial-title="initialTitle" @save="onSave" @cancel="onCancel"
                        @delete="onDelete" />
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed } from "@vue/composition-api";
import { useTranslations } from "@/@core/libs/i18n";
import TagForm from "./TagForm.vue";

export default {
    name: "TagFormDialog",
    components: {
        TagForm
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        tag: {
            type: Object,
            default: null
        },
        mode: {
            type: String,
            default: 'create',
            validator: value => ['create', 'edit'].includes(value)
        },
        initialTitle: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit }) {
        const { t } = useTranslations();

        // Control dialog visibility
        const dialogVisible = computed({
            get: () => props.show,
            set: (value) => {
                if (!value) {
                    emit('close');
                }
            }
        });

        const getDialogTitle = () => {
            return props.mode === 'edit' ? t('Muokkaa avainsanaa') : t('Luo uusi avainsana');
        };

        const onSave = (savedTag) => {
            emit('save', savedTag);
        };

        const onDelete = (savedTag) => {
            emit('delete');
        };

        const onCancel = () => {
            emit('cancel');
        };

        return {
            dialogVisible,
            getDialogTitle,
            onSave,
            onCancel,
            onDelete
        };
    }
};
</script>
